"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const useRecaptchaReset = () => {
    React.useEffect(() => {
        return () => {
            setTimeout(() => {
                $('.grecaptcha-badge')
                    .filter((index, element) => {
                    return $(element).closest('.recaptcha-mounted').length === 0;
                })
                    .remove();
            });
        };
    }, []);
};
exports.default = useRecaptchaReset;
